// Add to your queries.js file
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { fetch } from "libs";
import { UPDATE_MODEL_THUMBNAIL } from 'api';

export const useUpdateModelThumbnail = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async ({ modelUsername, thumbnailFile }: {modelUsername: string, thumbnailFile: File}) => {
      // Create FormData object to send the thumbnail file
      const formData = new FormData();
      formData.append('thumbnail', thumbnailFile);
      
      
      const response = await fetch(UPDATE_MODEL_THUMBNAIL(modelUsername), {
        method: 'POST',
        body: formData,
      });
      
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["models", { pageSize: 11, tags: [] }]
      });
      
   
    }
  });
};
 export default useUpdateModelThumbnail 